// NK CSV EXPORTER
(function ($) {
  // PAUSE THE FUNCTION FOR 1 SECOND
  setTimeout(function () {
    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = today.getMonth() + 1;
    var dd = today.getDate();
    var todays_date = yyyy + "-" + mm + "-" + dd;
    // GET VARS FROM THE PAGE
    var the_event_title = $("#the_title").text();
    // WRITE THE FILENAME HERE
    var the_filename = the_event_title + "_" + todays_date + ".csv";
    var options = {
      // PASS THE FILENAME HERE AS A SIMPLE VAR WITHOUT ANY PROCESSING
      filename: the_filename,
      /* action='output' options   */
      appendTo: "body",
      /* general options */
      separator: ",",
      newline: "\n",
      quoteFields: true,
      excludeColumns: "",
      excludeRows: "",
    };

    function quote(text) {
      return '"' + text.replace('"', '""') + '"';
    }

    function download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }

    function convert(table) {
      var output = "";
      var rows = table.find("tr").not(options.excludeRows);
      var numCols = rows
        .first()
        .find("td,th")
        .filter(":visible")
        .not(options.excludeColumns).length;
      console.log(numCols);
      rows.each(function () {
        $(this)
          .find("td,th")
          .filter(":visible")
          .not(options.excludeColumns)
          .each(function (i, col) {
            col = $(col);
            output += options.quoteFields ? quote(col.text()) : col.text();
            console.log(i);
            if (i !== numCols - 1) {
              output += options.separator;
            } else {
              output += options.newline;
            }
          });
      });
      return output;
    }
    $.fn.table2csv = function (action, opt) {
      if (typeof action === "object") {
        opt = action;
        action = "download";
      } else if (action === undefined) {
        action = "download";
      }
      $.extend(options, opt);
      var table = this; // TODO use $.each
      var csv = convert(table);
      switch (action) {
        case "download":
          download(options.filename, csv);
          break;
        case "output":
          // var csv = convert(table);
          $(options.appendTo).append($("<pre>").text(csv));
          break;
      }
      return this;
    };
  }, 1000);
})(jQuery);
